import { ErrorResponse, onError } from '@apollo/client/link/error';
import { toast } from 'react-toastify';
import * as Sentry from '@sentry/react';

export const toastErrorLink = onError((error) => {
  captureSentryError(error);
  toast('Oops! Something went wrong on our end.', {
    toastId: 'common.error.message',
  });
});

const captureSentryError = (error: ErrorResponse) => {
  const { graphQLErrors, networkError, operation } = error;
  Sentry.withScope((scope) => {
    let error = '';
    if (graphQLErrors && graphQLErrors.length > 0) {
      const graphQLErrorMessage = graphQLErrors
        .map((e) => e.message)
        .join(', ');
      scope.setExtra('GraphQL Error', graphQLErrorMessage);
      error = graphQLErrorMessage;
    }
    if (networkError) {
      const networkErrorMessage = networkError.message;
      scope.setExtra('Network Error', networkErrorMessage);
      if ('statusCode' in networkError && networkError.statusCode) {
        scope.setExtra('Status Code', networkError.statusCode);
      }
      error = networkErrorMessage;
    }
    if (error) {
      error = `GraphQL error for operation ${operation.operationName}: ${error}`;
      scope.setExtra('Operation', operation.operationName);
      scope.setExtra('Variables', JSON.stringify(operation.variables));
      scope.setExtra('Query', JSON.stringify(operation.query));
      Sentry.captureException(networkError ?? new Error(error));
    }
  });
};
